import { GridReadyEvent } from 'ag-grid-community';
import React, { useEffect } from 'react';

import DataTable, { DataTableProps } from './DataTable.component';

interface DataTableWithPinnedBottomProps<T extends Record<string, any>>
  extends Omit<DataTableProps, 'rowData'> {
  rowData?: T[];
  pinnedBottomRowData?: T[];
}

export const DataTableWithPinnedBottom = <T extends Record<string, any>>(
  props: DataTableWithPinnedBottomProps<T>
) => {
  useEffect(() => {
    if (props.gridRef?.current?.api) {
      props.gridRef.current.api.setPinnedBottomRowData(
        props.pinnedBottomRowData || []
      );
    }
  }, [props.gridRef, props.pinnedBottomRowData]);

  const onGridReady = (params: GridReadyEvent) => {
    if (props.onGridReady) {
      props.onGridReady(params);
    }
    if (params.api) {
      params.api.setPinnedBottomRowData(props.pinnedBottomRowData || []);
    }
  };

  const { pinnedBottomRowData, ...restProps } = props;

  return (
    <DataTable
      {...restProps}
      gridRef={props.gridRef}
      onGridReady={onGridReady}
      rowData={props.rowData || []}
    />
  );
};

DataTableWithPinnedBottom.displayName = 'DataTableWithPinnedBottom';
